import { register } from '@shopify/theme-sections';
import Accordion from '../utilities/accordion';
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

register('collection-filters', {
    onLoad() {
        const filterCategories = document.getElementsByClassName('filter-category');
        if (filterCategories.length > 0) {
            [...filterCategories].forEach(function(category) {
                const items = category.querySelectorAll('li');
                if (items.length === 0) {
                    category.parentNode.removeChild(category);
                }
            });
            if (filterCategories.length === 0) {
                const filterClear = document.getElementsByClassName('filter-clear');
                if (filterClear.length > 0) {
                    filterClear[0].parentNode.removeChild(filterClear[0]);
                }
            }
        }
        const filterCategoriesShowMore = document.getElementsByClassName('filter-category__show-more');
        if (filterCategoriesShowMore.length > 0 ) {
            [...filterCategoriesShowMore].forEach(function(showMoreButton) {
                const items = showMoreButton.parentNode.querySelectorAll('.filter-category__more-filters li');
                if (items.length === 0) {
                    showMoreButton.parentNode.parentNode.removeChild(showMoreButton.parentNode);
                } else {
                    showMoreButton.addEventListener('click', function(event) {
                        const button = event.target;
                        button.parentNode.classList.toggle('show');
                    });
                }
            })
        }
        if (filterCategories.length > 0) {
            new Accordion({
                element: '.filters',
                titleClass: 'filter-category__title',
                contentClass: 'filter-category__content',
                onlyOneOpen: false,
                hideBody: false,
                breakpoints: null,
            });
        }
        const filters = document.querySelector('.collection-filters');
            
        function showFilters() {
            //Get window scrolltop position
            if (filters) {
                disableBodyScroll(filters.querySelector('.simplebar-content-wrapper'));
                document.body.classList.add('show-filters');
            }
        }
        function hideFilters() {
            //Get window scrolltop position
            if (filters) {
                enableBodyScroll(filters.querySelector('.simplebar-content-wrapper'));
                document.body.classList.remove('show-filters');
            }
        }
        const buttonsShowFilters = document.querySelectorAll('[data-show-filters]');
        if (buttonsShowFilters.length > 0) {
            buttonsShowFilters.forEach( showFilterButton => {
                showFilterButton.onclick = showFilters;
            });
        }
        const buttonsHideFilters = document.querySelectorAll('[data-hide-filters]');
        if (buttonsHideFilters.length > 0) {
            buttonsHideFilters.forEach( hideFilterButton => {
                hideFilterButton.onclick = hideFilters;
            });
        }
    }
});